module.exports = __webpack_public_path__ + "img/1575800916.0efc1cc1.jpg";